import { BusinessDownloadConfig } from '../types';
import { DATASOURCE_METRICS_COMPANY_DETAILS } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/constantDownload';
// const COMPANIES_DOWNLOAD_URL = '/api/v1/intelligence_pc/topChartCompanyExcel';
// const COMPANIES_DOWNLOAD_URL = '/api/v1/intelligence_pc/topChartCompanyExcelBG'; // 新接口
const COMPANIES_DOWNLOAD_URL = '/api/v1/intelligence_pc/topChartCompanysExcel'; // 新接口
const TIME_SETTINGS_SEPARATE_TIPS_EN =
  'Data metrics which provided by NPD is only avaliable in month granularity,Mscience provides daily metrics for partial top PC/Console games only.';
// const TIME_SETTINGS_SEPARATE_TIPS_CN =
//   'Newzoo和NPD仅提供月粒度数据, Mscience仅提供部分头部PC/Console游戏的日粒度数据。';

const companiesConfig: BusinessDownloadConfig = {
  'companies-revenue': {
    apiUrl: COMPANIES_DOWNLOAD_URL,
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'sourceMetricSelector',
        field: 'download_metrics',
        defaultValue: [
          'mobile_revenue',
          'pc_digital_revenue',
          'console_digital_revenue',
          'pc_physical_revenue',
          'console_physical_revenue',
        ],
        options: [
          { label: 'Mobile Revenue', value: 'mobile_revenue', source: 'appannie' },
          { label: 'PC Digital Revenue', value: 'pc_digital_revenue', source: 'mscience' },
          {
            label: 'Console Digital Revenue',
            value: 'console_digital_revenue',
            source: 'mscience',
          },
          { label: 'PC Physical Revenue', value: 'pc_physical_revenue', source: 'npd' },
          { label: 'Console Physical Revenue', value: 'console_physical_revenue', source: 'npd' },
        ],
      },
      {
        label: 'dbi_label_basic_info_optional',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          games_owned_show: true,
          ipo_status_show: false,
          headquaters_show: false,
        },
        options: [
          { label: 'dbi_company_game_owned', value: 'games_owned_show' },
          { label: 'dbi_company_ipo_status', value: 'ipo_status_show' },
          { label: 'dbi_company_headquaters', value: 'headquaters_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
            message: TIME_SETTINGS_SEPARATE_TIPS_EN,
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
          {
            label: 'dbi_revenue_range_unit_setting',
            type: 'revenueUnitSettings',
            defaultValue: '',
            field: 'revenue_setting_unit',
          },
        ],
      },
    ],
  },
  'companies-downloads': {
    apiUrl: COMPANIES_DOWNLOAD_URL,
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_basic_info_optional',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          games_owned_show: true,
          ipo_status_show: false,
          headquaters_show: false,
        },
        options: [
          { label: 'dbi_company_game_owned', value: 'games_owned_show' },
          { label: 'dbi_company_ipo_status', value: 'ipo_status_show' },
          { label: 'dbi_company_headquaters', value: 'headquaters_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
            message: TIME_SETTINGS_SEPARATE_TIPS_EN,
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'companies-mentions': {
    apiUrl: COMPANIES_DOWNLOAD_URL,
    bubbleText: '',
    translate: true,
    formList: [
      {
        label: 'dbi_label_basic_info_optional',
        type: 'checkbox',
        field: 'data_sources',
        defaultValue: {
          games_owned_show: true,
          ipo_status_show: false,
          headquaters_show: false,
        },
        options: [
          { label: 'dbi_company_game_owned', value: 'games_owned_show' },
          { label: 'dbi_company_ipo_status', value: 'ipo_status_show' },
          { label: 'dbi_company_headquaters', value: 'headquaters_show' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'downlaod_date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
            message: '',
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
  'companies-detail': {
    apiUrl: 'api/v1/intelligence_pc/company/stats/metrics/downloads_excel',
    bubbleText: '',
    translate: true,
    formList: [
      {
        className: 'dbi-top-companies-source-metric-selector',
        label: 'dbi_label_metrics',
        type: 'cascadeCompanyMetricSelector',
        field: 'metrics',
        defaultValue: [['All', 'All']],
        cascadeOptions: DATASOURCE_METRICS_COMPANY_DETAILS,
        ifUseMetricsMap: true,
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'separate',
            field: 'downlaod_date_method',
            message:
              'The metric of Active Users has different granularities, you can get DAU/WAU/MAU when selecting the below options.',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country', value: 'market' },
              { label: 'dbi_label_separate_by_region', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};

export default companiesConfig;
